import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faForward, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";

const BRAND_LR = "linear-gradient(to right, #C04C2A, #4A1B13)";
const BRAND_DIAG = "linear-gradient(135deg, #C04C2A 0%, #8B2A15 55%, #4A1B13 100%)";

export default function ForwardTaskModal({
  task,
  employees,
  saving,
  assigneeId,
  note,
  onChangeAssignee,
  onChangeNote,
  onClose,
  onSubmit,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-0 sm:items-center sm:p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 flex min-h-[100dvh] w-full max-w-xl flex-col overflow-hidden bg-white dark:bg-gray-900 shadow-2xl sm:min-h-0 sm:max-h-[90vh] sm:rounded-3xl">
        <div className="relative overflow-hidden px-4 py-4 text-white sm:px-6 sm:py-5" style={{ background: BRAND_DIAG }}>
          <div className="pointer-events-none absolute -right-4 -top-4 h-24 w-24 rounded-full bg-white/5 blur-2xl" />

          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white/25 sm:right-5 sm:top-5"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <div className="pr-12">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.18em] text-orange-100">
              <FontAwesomeIcon icon={faForward} />
              Forward Task
            </div>
            <h3 className="mt-3 text-xl font-extrabold tracking-tight sm:text-2xl">{task.title}</h3>
            <p className="mt-2 text-sm text-orange-200">
              Change the assignee when another employee should handle the next action. Once this step is forwarded, that step stays locked.
            </p>
          </div>

          <div className="mt-4 h-1 overflow-hidden rounded-full bg-white/15">
            <div className="h-full w-full rounded-full bg-white/65" />
          </div>
        </div>

        <div className="flex-1 space-y-5 overflow-y-auto p-4 sm:p-6">
          <div>
            <label className="mb-2 block text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Forward To</label>
            <select
              value={assigneeId}
              onChange={(event) => onChangeAssignee(event.target.value)}
              className="fi"
            >
              <option value="">Select employee</option>
              {employees.map((employee) => (
                <option key={employee.id || employee.userId} value={employee.id}>
                  {employee.fullName}
                  {employee.employeeCode ? ` (${employee.employeeCode})` : ""}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-2 block text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Forward Note</label>
            <textarea
              value={note}
              onChange={(event) => onChangeNote(event.target.value)}
              className="fi min-h-[140px] resize-none"
              placeholder="Example: Need finance review before customer reply."
            />
          </div>
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-slate-100 bg-slate-50 dark:border-gray-800 dark:bg-gray-900 px-4 py-4 sm:flex-row sm:justify-end sm:px-6 sm:py-5">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-xl border border-slate-200 bg-white py-3 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 sm:w-auto sm:px-6 sm:py-2.5"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={saving}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-bold text-white shadow-sm transition hover:opacity-90 disabled:opacity-60 sm:w-auto sm:px-6 sm:py-2.5"
            style={{ background: BRAND_LR }}
          >
            <FontAwesomeIcon icon={saving ? faSpinner : faArrowRight} spin={saving} className="text-base sm:text-sm" />
            {saving ? "Forwarding..." : "Forward Task"}
          </button>
        </div>
      </div>

      <style>{`
        .fi { width:100%; border-radius:0.75rem; border:1px solid #e2e8f0; background:#fff; padding:0.75rem 1rem; font-size:0.875rem; color:#334155; outline:none; transition:border-color 0.15s,box-shadow 0.15s; }
        .fi:focus { border-color:#C04C2A; box-shadow:0 0 0 3px rgba(192,76,42,0.10); }
        .dark .fi { background:#1f2937; border-color:#374151; color:#e5e7eb; }
        .dark .fi:focus { border-color:#C04C2A; }
      `}</style>
    </div>
  );
}
